export const changeTariffFromBackend = async (url: string) => {
    // @ts-ignore
    $.modalable('open', {
        url,
    });
};
